import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import FeedbackForm from "./FeedbackForm";

const Header = ({ toggleTheme, theme }) => {
  const navigate = useNavigate();
  const { isLoggedIn, setIsLoggedIn } = useAuth();
  const [userEmail, setUserEmail] = useState('');
  const [usageCount, setUsageCount] = useState(null);
  const [dailyLimit, setDailyLimit] = useState(null);
  const [userNickname, setUserNickname] = useState('');
  const [showFeedback, setShowFeedback] = useState(false);

  useEffect(() => {
    const email = localStorage.getItem("email");
    const nickname = localStorage.getItem("nickname");
    const usage = localStorage.getItem("usage_count");
    const limit = localStorage.getItem("daily_limit");
    if (email) setUserEmail(email);
    if (nickname) setUserNickname(nickname);
    if (usage) setUsageCount(parseInt(usage));
    if (limit) setDailyLimit(parseInt(limit));
  }, [isLoggedIn]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("nickname");
    localStorage.removeItem("usage_count");
    localStorage.removeItem("daily_limit");
    setIsLoggedIn(false);
    setUserEmail("");
    navigate("/login");
  };

  return (
    <header className="w-full flex flex-col md:flex-row justify-between items-center px-4 py-4 border-b bg-white dark:bg-gray-800 text-white">
      <div className="text-center md:text-left mb-4 md:mb-0">
        <h1 className="text-lg sm:text-xl font-bold text-blue-600 dark:text-blue-300">말해조 🗣️</h1>
        <nav className="mt-2 text-sm">
          <Link to="/" className="hover:text-blue-400">J_Universe</Link>
          <span className="mx-2">|</span>
          <Link to="/home" className="hover:text-blue-400">말해조(Malhaejo)</Link>
          <span className="mx-2">|</span>
        </nav>
      </div>
      <div className="flex flex-col items-end gap-2 mt-4 md:mt-0">
        {isLoggedIn && (
            <div className="text-sm font-semibold text-green-300 text-center md:text-right w-full">
              어서오세요, <span className="text-yellow-400">{userNickname || userEmail}</span> 님
          </div>
        )}
         <div className="flex gap-2">
          {isLoggedIn ? (
              <button
                  onClick={handleLogout}
                  className="px-4 py-2 text-sm font-semibold text-white bg-red-500 rounded-full"
              >
                Sign out
              </button>
          ) : (
              <Link
                  to="/login"
                  className="px-4 py-2 text-sm font-semibold text-white bg-blue-500 rounded-full"
              >
                Sign in
              </Link>
          )}
           {!isLoggedIn && (
            <Link
              to="/signup"
              className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
            >
              Sign up
            </Link>
          )}
           {isLoggedIn && (
              <Link
                to="/mypage"
                className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
              >
                MyPage
              </Link>
           )}
         </div>
      </div>
    </header>
  );
};

export default Header;
